class layeredContent{
    constructor() {
        const layeredContentModules = Array.from(document.querySelectorAll('.layered-content'));
        layeredContentModules.forEach((module, i) => {
            const contentItems = Array.from(module.querySelectorAll('.content-wrapper > a')),
            images = Array.from(module.querySelectorAll('.image-wrapper > div'));
            contentItems.forEach((contentItem,j) => {
                contentItem.addEventListener('mouseenter', (e) => {
                    e.preventDefault();

                    contentItems.forEach((item,k) => {
                        item.classList.remove('active');
                    });
                    images.forEach((item,k) => {
                        item.classList.remove('active');
                    });
                    
                    contentItem.classList.add('active');
                    images[j].classList.add('active');
                    
                });
            });
        });
    }
}
window.app.add('layeredContent', new layeredContent());